function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Location from '../../geom/Location';
import EdgeEndBuilder from './EdgeEndBuilder';
import NodeMap from '../../geomgraph/NodeMap';
import RelateNodeFactory from './RelateNodeFactory';
var RelateNodeGraph = /*#__PURE__*/function () {
  function RelateNodeGraph() {
    _classCallCheck(this, RelateNodeGraph);
    RelateNodeGraph.constructor_.apply(this, arguments);
  }
  return _createClass(RelateNodeGraph, [{
    key: "insertEdgeEnds",
    value: function insertEdgeEnds(ee) {
      for (var i = ee.iterator(); i.hasNext();) {
        var e = i.next();
        this._nodes.add(e);
      }
    }
  }, {
    key: "getNodeIterator",
    value: function getNodeIterator() {
      return this._nodes.iterator();
    }
  }, {
    key: "copyNodesAndLabels",
    value: function copyNodesAndLabels(geomGraph, argIndex) {
      for (var nodeIt = geomGraph.getNodeIterator(); nodeIt.hasNext();) {
        var graphNode = nodeIt.next();
        var newNode = this._nodes.addNode(graphNode.getCoordinate());
        newNode.setLabel(argIndex, graphNode.getLabel().getLocation(argIndex));
      }
    }
  }, {
    key: "build",
    value: function build(geomGraph) {
      this.computeIntersectionNodes(geomGraph, 0);
      this.copyNodesAndLabels(geomGraph, 0);
      var eeBuilder = new EdgeEndBuilder();
      var eeList = eeBuilder.computeEdgeEnds(geomGraph.getEdgeIterator());
      this.insertEdgeEnds(eeList);
    }
  }, {
    key: "computeIntersectionNodes",
    value: function computeIntersectionNodes(geomGraph, argIndex) {
      for (var edgeIt = geomGraph.getEdgeIterator(); edgeIt.hasNext();) {
        var e = edgeIt.next();
        var eLoc = e.getLabel().getLocation(argIndex);
        for (var eiIt = e.getEdgeIntersectionList().iterator(); eiIt.hasNext();) {
          var ei = eiIt.next();
          var n = this._nodes.addNode(ei.coord);
          if (eLoc === Location.BOUNDARY) n.setLabelBoundary(argIndex);else {
            if (n.getLabel().isNull(argIndex)) n.setLabel(argIndex, Location.INTERIOR);
          }
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RelateNodeGraph;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}();
export { RelateNodeGraph as default };
RelateNodeGraph.constructor_ = function () {
  this._nodes = new NodeMap(new RelateNodeFactory());
};